import { Spinner, SpinnerProps } from "@fluentui/react-components";
import * as React from "react";
import styles from "./Loading.module.scss";
export interface ILoadingProps extends SpinnerProps {}

export function Loading(props: ILoadingProps) {
	return (
		<div className={styles.loading}>
			<Spinner label="Loading..." size="large" {...props}></Spinner>
		</div>
	);
}
